import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
  noticeList: {
    articleidx: number;
    branch: string;
    commentcount: number;
    deletebtn: string;
    name: string;
    title: string;
    writetime: string;
  }[];
}

const NoticeBox = ({ noticeList }: Props) => {
  const [data, setData] = useState({
    type: 'notice',
    title: '공지사항',
    content: '',
  });

  useEffect(() => {
    if (noticeList.length > 0) {
      setData({
        type: 'notice',
        title: '공지사항',
        content: noticeList[0].title,
      });
    }
  }, [noticeList]);

  const renderContent = () => {
    if (data.type === 'notice') {
      return (
        <>
          <img src="/assets/images/icon/megaphone-red.svg" alt="" />
          {/* <Category color="#F45551">{data.title}</Category> */}
          <Divider />
          <div
            style={{
              width: '100%',
              textOverflow: `ellipsis`,
              overflow: `hidden`,
            }}
          >
            <ContentBox>
              <EllipsisText>{data.content}</EllipsisText>
            </ContentBox>
          </div>
        </>
      );
    } else if (data.type === 'event') {
      return (
        <>
          <img src="/assets/images/icon/gift.svg" alt="" />
          {/* <Category color="#F50">{data.title}</Category> */}
          <Divider />
          <ContentBox>
            <EllipsisText>{data.content}</EllipsisText>
          </ContentBox>
        </>
      );
    } else {
      return (
        <>
          <img src="/assets/images/icon/flight.svg" alt="" />
          {/* <Category color="#008AFF">{data.title}</Category> */}
          <Divider />
          <ContentBox>
            <EllipsisText>{data.content}</EllipsisText>
          </ContentBox>
        </>
      );
    }
  };

  return (
    <Container>
      <Inner to="/board">{renderContent()}</Inner>
    </Container>
  );
};
export default NoticeBox;

const ContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  color: #616161;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
`;

const EllipsisText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

const Container = styled.div`
  width: 100%;
  padding: 16px;
`;

const Inner = styled(Link)`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  color: #616161;
  cursor: pointer;
  box-shadow: 0px 4px 24px rgba(61.35, 69.44, 78.22, 0.1);
  text-decoration: none;
`;

const Category = styled.span<{ color: string }>`
  font-weight: 700;
  color: ${({ color }) => color};
`;

const Divider = styled.div`
  width: 1px;
  height: 12px;
  background-color: rgba(112, 115, 124, 0.16);
`;
